import { Box } from '@domain-group/suit-theme'

import type { LayoutTemplateModel } from '@models/types'

interface LayoutTemplateTileProps {
  callbacks: {
    selectLayoutTemplate: VoidFunction,
  },
  layoutTemplate: LayoutTemplateModel,
  selected: boolean,
}

const LayoutTemplateTile = (props: LayoutTemplateTileProps) => {
  const {
    callbacks: {
      selectLayoutTemplate,
    },
    layoutTemplate,
    selected = false,
  } = props

  return (
    <Box
      alignItems="center"
      backgroundSize="contain"
      backgroundPosition="center center"
      backgroundRepeat="no-repeat"
      border="1px solid"
      borderColor={selected ? 'blue' : 'lineColor'}
      borderRadius="5px"
      fontSize="xsmall"
      justifyContent="center"
      onClick={selectLayoutTemplate}
      opacity={selected ? 1 : 0.5}
      padding="small"
      style={{
        backgroundImage: layoutTemplate.previews?.large ? `url(${layoutTemplate.previews.large})` : undefined,
        cursor: 'pointer',
      }}
    >
      {layoutTemplate.title}
    </Box>
  )
}

export default LayoutTemplateTile
